var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0359 12.9408C15.6219 13.5268 15.6219 14.476 15.0359 15.0619C14.7453 15.3549 14.3609 15.5002 13.9766 15.5002C13.5922 15.5002 13.2087 15.3537 12.9163 15.0607L7.97656 10.1236L3.03734 15.0596C2.74437 15.3549 2.36047 15.5002 1.97656 15.5002C1.59266 15.5002 1.20922 15.3549 0.916016 15.0596C0.330078 14.4736 0.330078 13.5244 0.916016 12.9385L5.85664 7.99785L0.916016 3.05957C0.330078 2.47363 0.330078 1.52441 0.916016 0.938477C1.50195 0.352539 2.45117 0.352539 3.03711 0.938477L7.97656 5.88145L12.9172 0.94082C13.5031 0.354883 14.4523 0.354883 15.0383 0.94082C15.6242 1.52676 15.6242 2.47598 15.0383 3.06191L10.0977 8.00254L15.0359 12.9408Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a3b37939e786cedf76c3182e80658a1d.svg";
export { ForwardRef as ReactComponent };